import {Component , ElementRef , OnInit , ViewChild} from '@angular/core';
import {PictureService} from '../../../../core/services/picture.service';
import {fuseAnimations} from '../../../../core/animations';
import {PictureFormDialogComponent} from './setting-form/setting-form.component';
import { MatDialog } from '@angular/material/dialog';
import { EventService } from '../../../../core/services/event.service';
import { OpenPictureModalComponent } from './open-pictures/open-pictures.modal';
@Component({
    selector: 'pictures-page',
    templateUrl: './pictures.component.html',
    styleUrls: ['./pictures.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class PicturesComponent implements OnInit {
  pictures;
  _albums = [];
  dialogRef: any;

  constructor (public dialog: MatDialog , private pictureService: PictureService ,
               public eventService: EventService) {
    this.pictureService.onPictureChanged.subscribe((res) => {
      this.pictures = this.pictureService.pictures;
      this._albums = [];
      for (let i = 0; i < this.pictures.length; i++) {
        const src = this.pictures[ i ].name;
        const caption = '';
        const thumb = '';
        const album = {
          src: src ,
          caption: caption ,
          thumb: thumb
        };

        this._albums.push(album);
      }
    });
  }

  ngOnInit () {

  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  open (index: number): void {
    const dialogRef = this.dialog.open(OpenPictureModalComponent, {
      width: '800px',
      height: '600px',
      data: {pictures: this._albums, index: index},
    });
  }

  deletePicture (i) {
    this.pictureService.deletePicture(this.pictures[ i ].id).subscribe((res) => {
      if (res) {
        this.pictureService.getPictures().then();
      }
    });
  }

  newPicture () {
    this.dialogRef = this.dialog.open(PictureFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: 'auto',
      data: {
        action: 'new'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe((response: any) => {
        this.pictureService.addPicture(response).subscribe((res) => {
          if (res) {
            this.pictureService.getPictures().then();
          }
        });
      });
  }

}

